(function () {
  class KhuloudSignatureWardrobe {
    constructor(root) {
      this.root = root;
      this.variantId = Number(root.dataset.variantId);
      this.cartUrl = root.dataset.cartUrl || '/cart';
      this.canAdd = root.dataset.canAdd === 'true';
      this.steps = ['full', 'one', 'two'];
      this.activeStep = 'full';
      this.state = { full: null, one: null, two: null };
      this.cards = Array.from(root.querySelectorAll('[data-card]'));
      this.addButton = root.querySelector('[data-add]');
      this.stickyButton = root.querySelector('[data-sticky-action]');
      this.message = root.querySelector('[data-message]');
      this.prevButton = root.querySelector('[data-prev-step]');
      this.nextButton = root.querySelector('[data-next-step]');
      this.tabs = Array.from(root.querySelectorAll('[data-step-tab]'));
      this.bind();
      this.seedHero();
      this.setStep('full', false);
      this.sync();
    }

    bind() {
      this.cards.forEach((card) => card.addEventListener('click', () => this.select(card)));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.setStep(tab.dataset.stepTab)));
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.move(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1));
      if (this.addButton) this.addButton.addEventListener('click', () => this.add());
      if (this.stickyButton) {
        this.stickyButton.addEventListener('click', () => {
          this.root.querySelector('#BuildSignatureWardrobe')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    seedHero() {
      this.steps.forEach((group) => {
        const card = this.root.querySelector(`[data-card][data-group="${group}"]`);
        const image = this.root.querySelector(`[data-preview-image="${group}"]`);
        if (!card || !image) return;
        image.src = card.dataset.image || '';
        image.alt = card.dataset.alt || '';
      });
    }

    select(card) {
      const group = card.dataset.group;
      this.state[group] = {
        title: card.dataset.title || '',
        variantId: card.dataset.variantId || '',
        image: card.dataset.image || '',
        alt: card.dataset.alt || ''
      };

      this.cards
        .filter((item) => item.dataset.group === group)
        .forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

      card.closest('[data-picker]')?.classList.remove('is-missing');
      this.sync();

      const index = this.steps.indexOf(group);
      if (index >= 0 && index < this.steps.length - 1) {
        window.setTimeout(() => this.setStep(this.steps[index + 1]), 180);
      }
    }

    setStep(group, scroll = true) {
      if (!this.steps.includes(group)) return;
      this.activeStep = group;

      this.root.querySelectorAll('[data-picker]').forEach((picker) => {
        picker.classList.toggle('is-active', picker.dataset.picker === group);
      });

      this.tabs.forEach((tab) => {
        const active = tab.dataset.stepTab === group;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (scroll) {
        this.root.querySelector('#BuildSignatureWardrobe')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      this.syncControls();
    }

    move(delta) {
      const index = this.steps.indexOf(this.activeStep);
      const next = this.steps[index + delta];
      if (next) this.setStep(next);
    }

    sync() {
      this.steps.forEach((group) => {
        const item = this.state[group];
        if (!item) return;

        const summary = this.root.querySelector(`[data-summary="${group}"]`);
        const tabChoice = this.root.querySelector(`[data-tab-choice="${group}"]`);
        const previewName = this.root.querySelector(`[data-preview-name="${group}"]`);
        const previewImage = this.root.querySelector(`[data-preview-image="${group}"]`);

        if (summary) summary.textContent = item.title;
        if (tabChoice) tabChoice.textContent = item.title;
        if (previewName) previewName.textContent = item.title;
        if (previewImage) {
          previewImage.src = item.image;
          previewImage.alt = item.alt;
        }
      });

      const complete = this.isComplete();
      if (this.addButton) {
        this.addButton.disabled = !complete || !this.canAdd;
        if (!this.canAdd) this.addButton.textContent = complete ? 'Ready for launch' : 'Choose your 3';
      }
      if (this.stickyButton) this.stickyButton.textContent = complete ? 'Review wardrobe' : 'Choose your 3';
      if (this.message && complete) {
        this.message.textContent = this.canAdd
          ? 'Your Khuloud wardrobe is ready.'
          : 'Draft preview only. Shopify enables cart add when this product is made available to Online Store.';
      }
      this.syncControls();
    }

    syncControls() {
      const index = this.steps.indexOf(this.activeStep);
      if (this.prevButton) this.prevButton.disabled = index <= 0;
      if (this.nextButton) {
        this.nextButton.disabled = index >= this.steps.length - 1;
        this.nextButton.textContent = index >= this.steps.length - 2 ? 'Review' : 'Next';
      }

      this.tabs.forEach((tab) => {
        const group = tab.dataset.stepTab;
        tab.classList.toggle('is-complete', Boolean(this.state[group]));
      });
    }

    isComplete() {
      return Boolean(this.state.full && this.state.one && this.state.two);
    }

    missingGroup() {
      return this.steps.find((group) => !this.state[group]);
    }

    showMissing() {
      const group = this.missingGroup();
      const picker = group ? this.root.querySelector(`[data-picker="${group}"]`) : null;
      if (!picker) return;
      this.setStep(group);
      picker.classList.add('is-missing');
      if (this.message) this.message.textContent = 'Choose all three bottles to continue.';
    }

    properties() {
      return {
        'Bundle structure': '1 x 100mL + 2 x 30mL',
        'Bundle total': '160mL',
        'Full-size 100mL': this.state.full.title,
        'Rotation one 30mL': this.state.one.title,
        'Rotation two 30mL': this.state.two.title,
        '_full_size_variant_id': this.state.full.variantId,
        '_rotation_one_variant_id': this.state.one.variantId,
        '_rotation_two_variant_id': this.state.two.variantId
      };
    }

    async add() {
      if (!this.isComplete()) {
        this.showMissing();
        return;
      }

      if (!this.canAdd) {
        if (this.message) this.message.textContent = 'Draft preview only. The selections are working; cart add is blocked until launch availability is enabled.';
        return;
      }

      this.addButton.disabled = true;
      this.addButton.textContent = 'Adding...';
      if (this.message) this.message.textContent = 'Adding your wardrobe to cart...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: this.variantId,
                quantity: 1,
                properties: this.properties()
              }
            ]
          })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add this wardrobe to cart.');
        }

        window.location.href = this.cartUrl;
      } catch (error) {
        this.addButton.disabled = false;
        this.addButton.textContent = 'Add wardrobe to cart';
        if (this.message) this.message.textContent = error.message;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-signature-wardrobe]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      new KhuloudSignatureWardrobe(root);
    });
  });
})();
